module.exports = "/images/milano-8.jpg";